export const dictionary = [
    ["eksploatacja","Eksploatacja"],
    ["garaz", "Garaż"],
    ["garaz_eksploatacja", "Garaż eksploatacja"],
    ["strych", "Strych"],
    ["utrzymanie_czystosci", "Utrzymanie czystości"],
    ["wywoz_smieci", "Wywóz śmieci"],
    ["fundusz_remontowy", "Fundusz remontowy"],
    ["konserw_domofonu", "Konserwacja domofonu"],
    ["konserw_windy", "Konserwacja windy"],
    ["opl_za_adm", "Opłata za administrację"],
    ["zimna_woda", "Zimna woda"],
    ["ciepla_woda", "Ciepła woda"],
    ["abonament_cw", "Abonament - c.w."],
    ["co", "Centralne ogrzewanie"],
    ["energia_el_lokalu", "Energia elekt. lokalu"],
    ["ryczalt_gaz", "Ryczałt za gaz"],
    ["zagosp_terenu", "Zagospodarowanie terenu"],
    ["antena", "Opłata za antenę"],
    ["rozliczanie_wody", "Sposób rozliczania wody"],
    ["data_od", "Data obowiązywania"],
    ["komorka", "Komórka"],
    ["imie_nazwisko", "Imię i nazwisko"],
    ["ulica", "Ulica"],
    ["numer_domu", "Numer budynku"],
    ["numer_lokalu", "Numer mieszkania"],
    ["kod_pocztowy", "Kod pocztowy"],
    ["miejscowosc", "Miejscowość"],
    ["czy_strych", "Strych"],
    ["czy_komorka", "Komórka"],
    ["strych_metraz", "Metraż strychu"],
    ["komorka_metraz", "Metraż komórki"],
    ["czy_garaz", "Garaż"],
    ["garaz_metraz", "Metraż garażu"],
    ["status_mieszkania", "Status"],
    ["data_zasiedlenia", "Data zasiedlenia"],
    ["data_zwolnienia", "Data zwolnienia"],
    ["lokal_metraz", "Metraż lokalu"],
    ["liczba_domownikow", "Liczba domowników"],
    ["klatka", "Klatka"],
    ["czy_nota", "Nota obciążeniowa"],
    ["czy_zarzad", "Członek zarządu wspólnoty"],
    ["nip", "NIP"],
    ["czy_abonament_cw", "Abonament - c.w."],
    ["czy_ciepla_woda", "Ciepła woda"],
    ["czy_co", "Centralne ogrzewanie"],
    ["czy_eksploatacja", "Eksploatacja"],
    ["czy_konserw_windy", "Konserwacja windy"],
    ["czy_opl_za_adm", "Opłata za administrację"],
    ["czy_wywoz_smieci", "Wywóz śmieci"],
    ["czy_zimna_woda", "Zimna woda"],
  ];

export const translate = (word) => { 
    let result = dictionary.filter((a)=>a[0]===word);
    return result.length > 0 ? result[0][1] : word;
}

export const rodzaj_rozliczenia = (rodzaj, czy_woda) => {
  if (czy_woda == "zimna_woda" || czy_woda == "ciepla_woda")
    return "m³"

  switch (rodzaj) {
    case '1': return "opłata stała";
    case '3': return "zł/os."
    case '5': return "m² p.u.";
    case '9': return "m²";
    case '16': return "m² p.u.";
    case '17': return "m² p.u.";
    case '18': return "m² p.u.";
    default: return "-";
  }
}

export const zamienPolskieZnaki = (tekst) => {

  return tekst
    .replace(/ą/g, 'a')
    .replace(/ć/g, 'c') 
    .replace(/ę/g, 'e')
    .replace(/ł/g, 'l')
    .replace(/ń/g, 'n')
    .replace(/ó/g, 'o')
    .replace(/ś/g, 's')
    .replace(/ż/g, 'z')
    .replace(/ź/g, 'z')
    .replace(/Ą/g, 'A')
    .replace(/Ć/g, 'C')
    .replace(/Ę/g, 'E')
    .replace(/Ł/g, 'L')
    .replace(/Ń/g, 'N')
    .replace(/Ó/g, 'O')
    .replace(/Ś/g, 'S')
    .replace(/Ż/g, 'Z')
    .replace(/Ź/g, 'Z');
};